import React from 'react';
import { Typography, Box } from '@mui/material';

/**
 * Route-aware subtitle under the app bar (design-review #11).
 *
 * @param {object} props
 * @param {string} props.title - Primary context line
 * @param {string} [props.detail] - Optional secondary line (active tab, filter)
 */
const PageContextSubtitle = ({ title, detail = null }) => {
    if (!title) {
        return null;
    }

    return (
        <Box
            data-testid="page-context-subtitle"
            sx={{ px: 2, py: 0.5, borderBottom: 1, borderColor: 'divider', bgcolor: 'background.default' }}
        >
            <Typography variant="body2" color="text.secondary" component="p">
                {title}
                {detail ? ` · ${detail}` : ''}
            </Typography>
        </Box>
    );
};

export default PageContextSubtitle;
